import React from "react"
import Navbar from "react-bootstrap/Navbar"
import Nav from "react-bootstrap/Nav"
import NavLink from "../navlink"


export default function HeaderLayout() {
  return (
    <Navbar collapseOnSelect expand="md" bg="light" >
      <Navbar.Brand>Nucleo</Navbar.Brand>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="mr-auto">
          <NavLink link="/" linkName="Home"/>
          <NavLink link="/contact" linkName="Contacto"/>
          <NavLink link="/events" linkName="Eventos"/>
          <NavLink link="/contribution" linkName="Banco de Datos"/>
          <NavLink link="/platform" linkName="Plataforma de Interacción"/>
          <NavLink link="/comments" linkName="Comentarios y Propuesta"/>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  )
}
